module.exports = __webpack_public_path__ + "static/media/girl1.de5b404a.jpg";